import useDebounceCallback from "@/shared/hooks/useDebouncCallback";
import { useSearchParams } from "next/navigation";
import Flex from "../../common/Flex";
import type { FilterComponent } from "../filter.types";
import { Input } from "../../common/Input";

const QueryFilter: FilterComponent<string> = ({ applyFilter, placeholder }) => {
  const handleChange = useDebounceCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      applyFilter(event.target.value)(),
    1000
  );

  const currentState = useSearchParams().get("query") ?? "";

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"center"}
      className="md:pb-4 w-full"
    >
      <Input
        placeholder={placeholder}
        onChange={handleChange}
        type="text"
        className="h-11 rounded-full place bg-background border-border shadow-none w-full"
        defaultValue={currentState}
      />
    </Flex>
  );
};

export default QueryFilter;
